import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const EmailVerification = () => {
  const [email, setEmail] = useState("");
  const [confirmationSaved, setConfirmationSaved] = useState(false);
  const [failed, setFailed] = useState(false);
  // Random confirmation token from the email link (no longer the user id).
  const token = useParams().id;

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  useEffect(() => {
    const getUserInfo = async () => {
      // Send email to backend
      try {
        const res = await fetch("/api/users/confirm/" + encodeURIComponent(token), {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        const data = await res.json();
        if (!res.ok) {
          setFailed(true);
          return;
        }
        setEmail(data.email || "");
        setConfirmationSaved(data.confirmed === true);
      } catch (err) {
        setFailed(true);
      }
    };
    getUserInfo();
  }, [token]);

  return (
    <div>
        {failed ? (
            <div>
                <h1>El enlace no es válido o ya expiró</h1>
                <p>Inicia sesión y te enviaremos un nuevo correo de confirmación.</p>
                <a href="/login" >Iniciar sesión</a>
            </div>
        ) : email !== "" && confirmationSaved == true ? (
            <div>
                <h1>¡Gracias por registrarte!</h1>
                <a href="/login" >Iniciar sesión</a>
            </div>
        ) : (
            <div>
                <h1> Comprobando Identidad... </h1>
            </div>
        )}
    </div>
  );
};

export default EmailVerification;
